import React from "react";
import { IconWrapper } from "./_styled";

const valueToIconAttributesMapping = {
  "maple-leaf": {
    glyph: "canada",
    color: "red",
    size: "sm",
  },
  "genetic-implication": {
    glyph: "dna",
    color: "red",
    size: "md",
  },
};

export default function iconProcessor() {
  const processIcon = (node) => {
    const value = node.attribs["data-value"];
    const attributes = valueToIconAttributesMapping[value];
    return (
      attributes && (
        <IconWrapper
          icon={{ ...attributes }}
          data-testid={`content-icon-${value}`}
        />
      )
    );
  };

  return { processIcon };
}
